const routes = [
    {
        name: 'exportarSintegraContabilidade',
        path: '/contabilidade/sintegra/exportar/:id',
        component: () => import('../views/ExportarSintegra'),
        
    },
    {
        path: '/contabilidade/troca_cfops/index/:empresaId',
        alias: ['/contabilidade/troca_cfops'],
        component: () => import('../views/ListarConversaoCfops'),
    },
    {
        path: '/contabilidade/troca_cfops/adicionar/:empresaId',
        component: () => import('../views/AdicionarConversaoCfops'),
    },
    {
        path: '/contabilidade/troca_cfops/editar/:empresaId/:id',
        component: () => import('../views/EditarConversaoCfops'),
    },
    {
        path: '/contabilidade/troca_cfops/visualizar/:empresaId/:id',
        component: () => import('../views/VisualizarConversaoCfops'),
    }
]

export default routes
